import React from 'react';

const WmsDashboardPage = () => {
  return <div>WMS Dashboard Page</div>;
};

export default WmsDashboardPage;
